import { View } from "@react-pdf/renderer";
import React from "react";
import { DEFAULT_FOLD_MARKS } from "../_defaults";
import { tw } from "../tailwind";

export function FoldMarks() {
	/** Computed */
	const marks = Object.keys(DEFAULT_FOLD_MARKS);

	/** Render */
	return (
		<React.Fragment>
			{marks.map((mark) => (
				<View
					key={mark}
					fixed
					style={{
						top: `${DEFAULT_FOLD_MARKS[mark as keyof typeof DEFAULT_FOLD_MARKS]}%`,
						width: mark === "middle" ? "15px" : "35px",
						...tw("h-[1px] bg-black absolute left-0"),
					}}
				/>
			))}
		</React.Fragment>
	);
}
